import { useContext } from 'react';

import { type ISpotContextData, SpotContext } from '../contexts';

export const useSpot = (): ISpotContextData => useContext(SpotContext);
